<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data() {
    return {
      cdata: {
        category: [
          "2.1",
          "2.2",
          "2.3",
          "2.4",
          "2.5",
          "2.6",
          "2.7",
          "2.8",
          "2.9",
          "2.10",
          "2.11",
          "2.12",
          "2.13",
          "2.14",
          "2.15"
        ],
        lineData: [
          18092,
          20728,
          24045,
          48348,
          32808,
          26097,
          39867,
          54715,
          48444,
          20415,
          56061,
          62677,
          59521,
          67560,
          18092
        ],
        barData: [
          4600,
          5000,
          5500,
          6500,
          7500,
          8500,
          9900,
          12500,
          14000,
          21500,
          23200,
          24450,
          25250,
          33300,
          4600
        ],
        rateData: []
      },
      data: [
        {
          lineData: [
            18092,
            20728,
            24045,
            48348,
            32808,
            26097,
            39867,
            54715,
            48444,
            20415,
            56061,
            62677,
            59521,
            67560,
            18092
          ],
          barData: [
            4600,
            5000,
            5500,
            6500,
            7500,
            8500,
            9900,
            12500,
            14000,
            21500,
            23200,
            24450,
            25250,
            33300,
            4600
          ]
        },
        {
          lineData: [
            18092,
            20728,
            34045,
            28348,
            42808,
            66097,
            29867,
            24715,
            41444,
            28415,
            56061,
            52677,
            39521,
            87560,
            38092
          ],
          barData: [
            8600,
            6000,
            4500,
            6500,
            7500,
            2500,
            6900,
            7500,
            12000,
            11500,
            14200,
            20450,
            25250,
            23300,
            14600
          ]
        },
        {
          lineData: [
            18092,
            20728,
            24045,
            48348,
            42808,
            26097,
            39867,
            54715,
            28444,
            30415,
            56061,
            42677,
            59521,
            27560,
            18092
          ],
          barData: [
            4600,
            5000,
            4500,
            6500,
            5500,
            8500,
            1900,
            2500,
            4000,
            11500,
            23200,
            24450,
            25250,
            33300,
            4600
          ]
        }
      ]
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.title = 'device 左中'
    // this.changeData(this.data)
  },
  methods: {
    changeData(data, timeout = 3000) {
      if (this.title) {
        // console.log(this.title, this.index)
      }
      let index = this.index >= data.length ? 0 : this.index
      // 更新数据
      this.cdata.lineData = this.data[index].lineData
      this.cdata.barData = this.data[index].barData

      index++
      this.index = index
      this.timeoutIndex = setTimeout(() => {
        this.changeData(data)
      }, timeout)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>